import { HTTP } from "../../services/api-service.js";
import commonObj from "../../services/common.js";
const common = new commonObj();
const baseURL = common.baseURL;

const quotationStore = {
  namespaced: true,
  state: {
    CurCode: "",
  },
  actions: {
    shipmarkDownload({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/shipmarkDownload", params)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    shipmarkupload({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/shipmarkupload", params)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    shipmarkDelete({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/shipmarkDelete", params)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fileUpload({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/fileUpload", params)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fileDownload({ commit, state }, params) {
      console.log("🚀 ~ file: quotationStore.js:44 ~ fileDownload ~ params", params)
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/fileDownload", params)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getQuotationList({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/QuoteList", params)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getQuotationDetails({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/Quotation", params)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    updateQuotation({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/SaveQuotation", param)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => [reject(e)]);
      });
    },
    createQuotation({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/NewQuotation", param)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    approveQuotation({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/ApproveQuotation", param)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => [reject(e)]);
      });
    },
    rejectQuotation({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/RejectQuotation", param)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteQuotation({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/DeleteQuotation", param)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => [reject(e)]);
      });
    },
    confirmQuotation({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/ConfirmQuotation", param)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    RecalGP({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/quote/RecalGP", param)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getSysStatus({ commit, state }) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseURL + "/qgl/listvalue", {
          tableNeedQuery: "SysStatus",
          isOuterJoin: false,
          searchCriteria: "TxType='QUOT'",
          orderBy: "",
          take: 100000,
          skip: 0
        })
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    quoteRpt({ commit, state }, param) {
        return new Promise((resolve, reject) => {
            HTTP.post(baseURL + '/quote/quoteRpt').then(response => {
                resolve(response);
            })
                .catch(e => {
                    reject(e);
                });
        });
    },
    printQuote({ commit, state }, param) {
        return new Promise((resolve, reject) => {
            HTTP.post(baseURL + '/quote/PrintQuotation', { txNum: param.txNum, rptID: param.rptID }, { responseType: 'blob' }).then(response => {
                resolve(response);
            })
                .catch(e => {
                    reject(e);
                });
        });
    },
  },
  mutations: {
    setCurCode(state, curCode) {
      state.CurCode = curCode;
    },
  }
};

export default quotationStore;
